import { useNavigate } from "react-router-dom";
import "./ProductCard.css";

function ProductCard({ product }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product/${product.id}`);
  };

  return (
    <div className="product-card" onClick={handleClick}>
      <img src={product.photo} alt={product.name} className="product-image" />
      <div className="product-details">
        <h3>{product.name}</h3>
        <p className="price">₹{product.price}</p>
        <button className="emi-btn">💳 EMI Options Available</button>
      </div>
    </div>
  );
}

export default ProductCard;
